import { AlcoholicDrinkData, SoftDrinksData } from "@/mock";
import { AppDispatch, AppState } from "@/store/configureStore";
import {
	setBrands,
	setCategories,
	setProducts,
} from "@/store/slices/categoryProductSlice";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";

const useFetchCategoryProducts = () => {
	const dispatch = useDispatch<AppDispatch>();
	const base_url = process.env.NEXT_PUBLIC_BASE_URL;
	const categoryProducts = useSelector((state: AppState) => state.categoryProduct);
	const location = useSelector((state: AppState) => state.location);

	const fetchCategoryProducts = async () => {
		if (!location?.activeLocation?.id) return;

		const { activeCategory, brand, minPrice, maxPrice, variant } = categoryProducts;
		const requestData: Record<string, any> = {
			branchId: location.activeLocation.id,
		};
		if (minPrice) requestData.minPrice = minPrice;
		if (maxPrice) requestData.maxPrice = maxPrice;
		if (activeCategory?.name) requestData.categoryName = activeCategory.name;
		if (brand?.length) requestData.brands = brand;
		if (variant) requestData.variant = variant;

		// console.log(requestData);

		try {
			const response = await axios.get(`${base_url}/api/drinks`, {
				params: requestData,
			});
			dispatch(setProducts(response?.data?.products));
		} catch (error) {
			// console.error("Error fetching category products:", error);
		}
	};
	const fetchAlcoholicCategories = async () => {
		try {
			// const response = await axios.get(`${base_url}/api/categories/alcoholic`);
			dispatch(setCategories(AlcoholicDrinkData));
		} catch (error) {
			// console.log(error);
		}
	};
	const fetchNonAlcoholicCategories = async () => {
		try {
			// const response = await axios.get(`${base_url}/api/categories/non-alcoholic`);
			dispatch(setCategories(SoftDrinksData));
		} catch (error) {
			// console.log(error);
		}
	};
	const fetchBrands = async (category: string | undefined) => {
		try {
			const response = await axios.get(`${base_url}/api/brands`, {
				params: { category: category },
			});

			dispatch(setBrands(response?.data?.result));
		} catch (error) {
			// console.log(error);
		}
	};

	return {
		fetchCategoryProducts,
		fetchAlcoholicCategories,
		fetchNonAlcoholicCategories,
		fetchBrands,
	};
};

export default useFetchCategoryProducts;
